<div class="activation-link-addon-card vox-card">
  <div class="activation-link-addon-card__name">
    <span class="activation-link-addon-card__title" translate>
      {{name}}
    </span>
    <span *ngIf="name !== subtitle" class="activation-link-addon-card__subtitle vox-text-small vox-text-dark-grey">
      {{subtitle}}
    </span>
  </div>
  <div class="activation-link-addon-card__right">
    <div class="activation-link-addon-card__quantity">
      <vox-quantity-select
        [ngModel]="addon?.quantity ?? 0"
        (ngModelChange)="updateValue($event)"
        [minQuantity]="min"
        [maxQuantity]="max" 
        [readonly]="min == max">
      </vox-quantity-select>
    </div>
    <div *ngIf="canRemove" class="activation-link-addon-card__remove">
      <button class="vox-btn activation-link-addon-card__remove-btn" (click)="onRemoveClicked()" type="button">
        <i class="icon-small-delete"></i>
      </button>
    </div>
  </div>
</div>